export const decisioningStudioAgentsAppGroupIdDsaIdTimingQuietHours =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/timing/quiet_hours";

export const decisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursCacheKeys =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/timing/quiet_hours";
